import React, { Component } from 'react';
import { Grid, Dropdown, Form, Button, Divider } from 'semantic-ui-react';
import ListAccounts from '../cancellations/ListAccounts';
import BreadcrumbCustom from '../../layout/BreadcrumbCustom';
import { holds, holdReason } from '../../utils/defaults';
import { getInquiryAccountDetails, postHold, getAccountDetails } from '../../utils/rest';
import * as SimpleReactValidator from 'simple-react-validator';
import MessageBox from '../../ui/MessageBox';
import Loading from '../Loading';
const initialState = {
    acoAccountId: "",
    acoConsumerId: "",
    acoInvoiceId: "",
    conLastName: "",
    conFirstName: "",
    conSsn: "",
    cltClientIds: []
}
class Hold extends Component {
    constructor(props) {
        super(props);
        this.validator = new SimpleReactValidator();
        this.formvalidator = new SimpleReactValidator();
        this.state = {
            searchItems: [],
            searchIndex: initialState,
            cltClientId: 0,
            open: false,
            openError: false,
            errorMessage: [],
            disabled: true,
            total: "",
            statusCode: "",
            holdRequestId: "",
            holdReason: "",
            holdNumDays: "",
            msg7open: false,
            searchStateChanged: false,
            loading: false,
        };
    }

    componentDidMount() {
        this.props.addItem("helpFile", "am_place-a-hold.md");
        if (this.props.params && this.props.params.id > 0) {
            this.getAccountInfo(this.props.params.id);
        }
    }

    componentWillUnmount() {
        this.props.addItem("helpFile", null);
    }

    getAccountInfo = (acoAccountId) => {
        getAccountDetails(this.props.items.currentCorporate, acoAccountId).then((response) => {
            if (response !== null && response instanceof Object) {
                this.setState({
                    searchIndex: {
                        ...this.state.searchIndex,
                        acoAccountId: this.props._ifNull(response.acoAccountId, ""),
                        acoInvoiceId: this.props._ifNull(response.acoInvoiceId, ""),
                        acoConsumerId: this.props._ifNull(response.conConsumerId, ""),
                        conLastName: this.props._ifNull(response.conLastName, ""),
                        conFirstName: this.props._ifNull(response.conFirstName, "") + " " + this.props._ifNull(response.conLastName, ""),
                        conSsn: this.props._ifNull(response.conSsn, ""),
                        cltClientIds: [this.props._ifNull(response.cltClientId, 0)]
                    },
                    total: this.props._ifNull(response.acoTotal, 0),
                    statusCode: this.props._ifNull(response.acoStatusCode, ""),
                    disabled: false,
                    cltClientId: this.props._ifNull(response.cltClientId, 0)
                });
            }
        })
    }

    handleFormChange = (e, evt) => {
        this.setState({
            [evt.name]: evt.value
        })
    }

    close = () => {
        this.setState({
            open: false,
            openError: false,
            loading: false,
        })
    }


    handleSubmit = (e) => {
        e.preventDefault();
        if (this.validator.allValid()) {
            this.setState({
                loading: true,
                searchIndex: {
                    ...this.state.searchIndex,
                    conLastName: ""
                }
            }, () => {
                if (this.state.searchStateChanged) {
                    getInquiryAccountDetails(this.props.items.currentCorporate, this.state.searchIndex).then((response) => {
                        if (response !== null && response instanceof Array) {
                            this.setState({
                                searchItems: response,
                                disabled: true,
                                open: true,
                                loading: false,
                                searchStateChanged: false
                            })
                        }
                    });
                } else {
                    this.setState({
                        open: true,
                        loading: false,
                        searchStateChanged: false
                    })
                }
            });
        } else {
            this.setState({
                errorMessage: this.props._errorItems(this.validator.fields),
                openError: true,
                loading: false,
            });
            this.forceUpdate();
        }
    }


    checkEmpty = (searchIndex) => {
        let r = false;
        for (let search in searchIndex) {
            if (searchIndex[search].toString().length > 0) {
                r = true;
                break;
            }
        }
        return r;
    }

    handleChange = (e, evt) => {
        this.setState({
            searchStateChanged: true,
            searchIndex: {
                ...this.state.searchIndex,
                [evt.name]: evt.value
            }

        })
    }
    enableSubmit = (row) => {
        this.setState({
            disabled: false,
            total: row.acoTotal,
            statusCode: row.acoStatusCode,
            open: false,
            cltClientId: row.cltClientId,
            searchIndex: {
                ...this.state.searchIndex,
                conSsn: row.conSsn,
                acoAccountId: row.acoAccountId,
                acoInvoiceId: row.acoInvoiceId,
                acoConsumerId: row.conConsumerId,
                conLastName: row.conLastName,
                conFirstName: row.conFirstName
            }
        })
    }

    handleHold = (e) => {
        e.preventDefault();
        if (this.formvalidator.allValid()) {
            this.setState({
                loading: true
            }, () => {
                let holdObject = {
                    holdReason: this.state.holdReason,
                    holdRequestId: this.state.holdRequestId,
                    acoAccountId: this.state.searchIndex.acoAccountId,
                    acoConsumerId: this.state.searchIndex.acoConsumerId,
                    holdNumDays: this.state.holdNumDays,
                    cltClientId: this.state.cltClientId,
                    ctd: 0
                }
                postHold(this.props.items.currentCorporate, holdObject).then((response) => {
                    if (response !== null) {
                        this.setState({
                            msg7open: true,
                            loading: false,
                            //searchIndex: initialState,
                            total: "",
                            statusCode: "",
                            holdRequestId: "",
                            holdReason: "",
                            holdNumDays: "",
                        })
                    }
                }).then(() => {
                    this.setState({
                        loading: false
                    })
                })
            });
        } else {
            this.setState({
                errorMessage: this.props._errorItems(this.formvalidator.fields),
                openError: true,
                loading: false,
            });
            this.forceUpdate();
        }
    }
    render() {
        return (
            <div>
                {this.state.loading ? <Loading /> : ""}
                <BreadcrumbCustom {...this.props} parent="Account Management" child={[{ name: "Place a Hold", url: null }]} />
                <Grid className="g-bkgd">
                    <Grid.Row>
                        <Grid.Column>
                            <Form className="small">
                                <Form.Group>
                                    <Form.Field width={6} className="required">
                                        <label>Select Client ID(s):</label>
                                        <Dropdown placeholder='Select Client ID(s)' className="fluid" multiple search selection options={this.props.items.clients.map((client) => { client.disabled = !client.allowedtoholdaccount; return client; })} name="cltClientIds" value={this.state.searchIndex.cltClientIds} onChange={this.handleChange} ></Dropdown>
                                        {this.validator.message('Client ID(s)', this.state.searchIndex.cltClientIds, 'required')}
                                    </Form.Field>
                                    <Form.Field width={10}>
                                    </Form.Field>
                                </Form.Group>
                                <Form.Group>
                                    <Form.Field width={3}>
                                        <label>Client Acct#:</label>
                                        <Form.Input placeholder={this.props.t("client.account")} type="text" name="acoInvoiceId" value={this.state.searchIndex.acoInvoiceId} onChange={this.handleChange} />
                                    </Form.Field>
                                    <Form.Field width={3}>
                                        <Form.Input label={this.props.t("our.account")+":"} placeholder={this.props.t("our.account")} type="text" name="acoAccountId" value={this.state.searchIndex.acoAccountId} onChange={this.handleChange} />
                                    </Form.Field>
                                    <Form.Field width={3}>
                                        <Form.Input label={this.props.t("consumer.name")+":"} placeholder={this.props.t("consumer.name.placeholder")} type="text" name="conLastName" value={this.state.searchIndex.conLastName} onChange={this.handleChange} />
                                    </Form.Field>
                                    <Form.Field width={3}>
                                        <Form.Input label='SSN:' placeholder='XXXXXXXXX' type="text" name="conSsn" value={this.state.searchIndex.conSsn} onChange={this.handleChange} />
                                    </Form.Field>
                                    <Form.Field width={4}>
                                        <Button className="left floated small button push-down" onClick={this.handleSubmit}>Search for My Account</Button>
                                    </Form.Field>
                                </Form.Group>
                                <Form.Group>
                                    <Form.Field width={3} disabled>
                                        <label>Total:</label>
                                        <Form.Input placeholder='Total' type="text" value={this.state.total} name="total" />
                                    </Form.Field>
                                    <Form.Field width={3} disabled>
                                        <label>Status:</label>
                                        <Form.Input placeholder='Status' type="text" value={this.state.statusCode} name="status" />
                                    </Form.Field>
                                    <Form.Field width={10}>
                                    </Form.Field>
                                </Form.Group>
                                <Divider />
                                <Form.Group>
                                    <Form.Field width={3} className="required" disabled={this.state.disabled} >
                                        <label>Days to Hold:</label>
                                        <Form.Select placeholder="Select Days" name="holdNumDays" options={holds} value={this.state.holdNumDays} onChange={this.handleFormChange} />
                                        {this.formvalidator.message('Days to Hold:', this.state.holdNumDays, 'required')}
                                    </Form.Field>
                                    <Form.Field width={3} className="required" disabled={this.state.disabled} >
                                        <label>Reason for Hold Request:</label>
                                        <Form.Select placeholder="Select" name="holdRequestId" options={this.props.items.holdReason.length  === 0 ? holdReason : this.props.items.holdReason} value={this.state.holdRequestId} onChange={this.handleFormChange} />
                                        {this.formvalidator.message('Reason for Hold Request:', this.state.holdRequestId, 'required')}
                                    </Form.Field>
                                    <Form.Field width={3} disabled={this.state.disabled} >
                                        <label>Comments:</label>
                                        <Form.TextArea rows="2" name="holdReason" value={this.state.holdReason} onChange={this.handleFormChange} />
                                    </Form.Field >
                                    <Form.Field width={2} disabled={this.state.disabled} >
                                        <Button.Group className="small push-down">
                                            <Button>{this.props.t("reset")}</Button>
                                            <Button.Or />
                                            <Button positive onClick={this.handleHold}>{this.props.t("submit")}</Button>
                                        </Button.Group>
                                    </Form.Field >
                                </Form.Group>
                            </Form>
                            <ListAccounts accounts={this.state.searchItems} open={this.state.open} close={this.close} {...this.props} enableSubmit={this.enableSubmit} />
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <MessageBox {...this.props} box={7} open={this.state.msg7open} close={() => { this.setState({ searchIndex: initialState, disabled: true, msg7open: false }) }} />
                <MessageBox {...this.props} size="mini" box={11} open={this.state.openError} close={this.close} required={this.state.errorMessage} />
            </div>
        );
    }
}
export default Hold;


// WEBPACK FOOTER //
// ./src/app/ui/holds/Hold.js